/* eslint-env browser */

// NOTE: This file must remain ES5-compatible because the theme build uses `gulp-uglify` (UglifyJS / ES5 parser).

(function () {
  var toggle = document.querySelector("[data-menu-toggle]");
  var nav = document.querySelector("[data-site-nav]");

  if (!toggle || !nav) {
    return;
  }

  toggle.addEventListener("click", function () {
    var expanded = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!expanded));
    nav.hidden = expanded;
  });
})();

(function () {
  var navbar = document.querySelector("[data-fc-navbar]");
  if (!navbar) {
    return;
  }

  if (navbar.getAttribute("data-fc-init") === "true") {
    return;
  }
  navbar.setAttribute("data-fc-init", "true");

  var dropdown = navbar.querySelector("[data-fc-dropdown]");
  var tabletNav = navbar.querySelector("[data-fc-tablet-nav]");
  var mobileAccordion = navbar.querySelector("[data-fc-mobile-accordion]");

  var desktopBtns = Array.prototype.slice.call(
    navbar.querySelectorAll("[data-fc-desktop-menu]"),
  );
  var dropdownPanels = Array.prototype.slice.call(
    navbar.querySelectorAll("[data-fc-panel]"),
  );

  var hamburgerBtns = Array.prototype.slice.call(
    navbar.querySelectorAll("[data-fc-hamburger]"),
  );

  var tabBtns = Array.prototype.slice.call(
    navbar.querySelectorAll("[data-fc-tab]"),
  );
  var tabPanels = Array.prototype.slice.call(
    navbar.querySelectorAll("[data-fc-tab-panel]"),
  );

  var accordionSections = Array.prototype.slice.call(
    navbar.querySelectorAll("[data-fc-accordion-section]"),
  );

  var demoLinks = Array.prototype.slice.call(
    navbar.querySelectorAll("[data-fc-demo-link]"),
  );

  var closeTimer = null;
  var currentSection = null;
  var isOpen = false;
  var mobileOpen = false;
  var currentTab = "Platform";
  var desktopTop = navbar.querySelector(".fc-nav-desktop .fc-nav-inner");

  function setDemoHref() {
    var path = "";
    try {
      path =
        window.location && window.location.pathname
          ? window.location.pathname
          : "";
    } catch (e) {
      path = "";
    }

    var href =
      path.indexOf("ai-suite") !== -1 ? "/request-ai-agent/" : "/request-demo/";

    for (var i = 0; i < demoLinks.length; i += 1) {
      demoLinks[i].setAttribute("href", href);
    }
  }

  function setDesktopAria() {
    for (var i = 0; i < desktopBtns.length; i += 1) {
      var btn = desktopBtns[i];
      var name = btn.getAttribute("data-fc-desktop-menu") || "";
      var expanded = Boolean(isOpen && currentSection === name);
      btn.setAttribute("aria-expanded", String(expanded));
    }
  }

  function showDropdownPanel(name) {
    for (var i = 0; i < dropdownPanels.length; i += 1) {
      var panel = dropdownPanels[i];
      var panelName = panel.getAttribute("data-fc-panel") || "";
      panel.classList.toggle("is-active", panelName === name);
    }
  }

  function closeDesktop() {
    isOpen = false;
    currentSection = null;
    if (dropdown) {
      dropdown.classList.remove("is-open");
    }
    setDesktopAria();
  }

  function openDesktop(name) {
    if (!dropdown) {
      return;
    }
    currentSection = name;
    isOpen = true;
    dropdown.classList.add("is-open");
    showDropdownPanel(name);
    setDesktopAria();
  }

  function cancelClose() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = setTimeout(function () {
      closeDesktop();
      closeTimer = null;
    }, 120);
  }

  // Desktop hover + keyboard focus
  for (var i = 0; i < desktopBtns.length; i += 1) {
    (function (btn) {
      var name = btn.getAttribute("data-fc-desktop-menu") || "";
      btn.addEventListener("mouseenter", function () {
        openDesktop(name);
        cancelClose();
      });
      btn.addEventListener("focus", function () {
        openDesktop(name);
        cancelClose();
      });
    })(desktopBtns[i]);
  }

  // Close dropdown when moving to a non-dropdown top-level link (e.g. Pricing)
  // Without this, hovering from "Company" -> "Pricing" keeps the dropdown open because the navbar hasn't been left.
  if (desktopTop) {
    var desktopTopLinks = Array.prototype.slice.call(
      desktopTop.querySelectorAll("a"),
    );
    for (var dl = 0; dl < desktopTopLinks.length; dl += 1) {
      (function (link) {
        link.addEventListener("mouseenter", function () {
          if (isOpen) {
            closeDesktop();
          }
          cancelClose();
        });
        link.addEventListener("focus", function () {
          if (isOpen) {
            closeDesktop();
          }
          cancelClose();
        });
        link.addEventListener("click", function () {
          if (isOpen) {
            closeDesktop();
          }
        });
      })(desktopTopLinks[dl]);
    }
  }

  // Hover-close guard
  navbar.addEventListener("mouseleave", function () {
    scheduleClose();
  });
  navbar.addEventListener("mouseenter", function () {
    cancelClose();
  });

  if (dropdown) {
    dropdown.addEventListener("mouseenter", function () {
      cancelClose();
    });
    dropdown.addEventListener("mouseleave", function () {
      scheduleClose();
    });
  }

  // Close on outside click
  document.addEventListener("click", function (e) {
    if (!isOpen) {
      return;
    }
    var target = e && e.target ? e.target : null;
    if (!target || !navbar.contains(target)) {
      closeDesktop();
    }
  });

  // Tablet tabs
  function setTab(name) {
    currentTab = name;
    for (var i = 0; i < tabBtns.length; i += 1) {
      var btn = tabBtns[i];
      var isActive = (btn.getAttribute("data-fc-tab") || "") === name;
      btn.classList.toggle("active", isActive);
      btn.setAttribute("aria-selected", String(isActive));
    }

    for (var j = 0; j < tabPanels.length; j += 1) {
      var panel = tabPanels[j];
      var panelName = panel.getAttribute("data-fc-tab-panel") || "";
      panel.classList.toggle("is-active", panelName === name);
    }
  }

  for (var t = 0; t < tabBtns.length; t += 1) {
    (function (btn) {
      btn.addEventListener("click", function () {
        var name = btn.getAttribute("data-fc-tab") || "";
        if (name) {
          setTab(name);
        }
      });
    })(tabBtns[t]);
  }

  // Mobile accordion: keep only one open
  for (var a = 0; a < accordionSections.length; a += 1) {
    (function (detailsEl) {
      detailsEl.addEventListener("toggle", function () {
        if (!detailsEl.open) {
          return;
        }
        for (var k = 0; k < accordionSections.length; k += 1) {
          if (accordionSections[k] !== detailsEl) {
            accordionSections[k].open = false;
          }
        }
      });
    })(accordionSections[a]);
  }

  // Hamburger open/close (tablet + mobile share the same state)
  function setMobileOpen(next) {
    mobileOpen = Boolean(next);

    for (var i = 0; i < hamburgerBtns.length; i += 1) {
      hamburgerBtns[i].classList.toggle("is-open", mobileOpen);
      hamburgerBtns[i].setAttribute("aria-expanded", String(mobileOpen));
    }

    if (tabletNav) {
      tabletNav.classList.toggle("is-open", mobileOpen);
    }
    if (mobileAccordion) {
      mobileAccordion.classList.toggle("is-open", mobileOpen);
    }

    // Always close desktop dropdown when mobile menu opens
    if (mobileOpen) {
      closeDesktop();
    }
  }

  for (var h = 0; h < hamburgerBtns.length; h += 1) {
    hamburgerBtns[h].addEventListener("click", function () {
      setMobileOpen(!mobileOpen);
    });
  }

  // Platform internal hover (applies to each panel instance)
  function initPlatformInstance(root) {
    if (!root || root.getAttribute("data-fc-platform-init") === "true") {
      return;
    }
    root.setAttribute("data-fc-platform-init", "true");

    var productItems = Array.prototype.slice.call(
      root.querySelectorAll("[data-fc-product]"),
    );
    var productPanels = Array.prototype.slice.call(
      root.querySelectorAll("[data-fc-product-panel]"),
    );

    function setActiveProduct(name) {
      for (var i = 0; i < productItems.length; i += 1) {
        var item = productItems[i];
        var isActive = (item.getAttribute("data-fc-product") || "") === name;
        item.classList.toggle("is-active", isActive);
      }

      for (var j = 0; j < productPanels.length; j += 1) {
        var panel = productPanels[j];
        var panelName = panel.getAttribute("data-fc-product-panel") || "";
        var isPanelActive = panelName === name;
        // Support both CSS-driven `.is-active` and the native `hidden` attribute.
        panel.classList.toggle("is-active", isPanelActive);
      }
    }

    // Default
    setActiveProduct("connected-cmms");

    for (var i = 0; i < productItems.length; i += 1) {
      (function (el) {
        var name = el.getAttribute("data-fc-product") || "";
        el.addEventListener("mouseenter", function () {
          if (name) {
            setActiveProduct(name);
          }
        });
        el.addEventListener("focus", function () {
          if (name) {
            setActiveProduct(name);
          }
        });
      })(productItems[i]);
    }
  }

  var platformRoots = Array.prototype.slice.call(
    navbar.querySelectorAll("[data-fc-platform]"),
  );
  for (var p = 0; p < platformRoots.length; p += 1) {
    initPlatformInstance(platformRoots[p]);
  }

  // Initial states
  setDemoHref();
  closeDesktop();
  setTab(currentTab);
  setMobileOpen(false);

  // Ensure default class-driven visibility matches initial state (no `hidden` usage)
  if (dropdown) {
    dropdown.classList.remove("is-open");
  }
})();

(function () {
  // When clicking a tag link (anywhere), persist the intended hub filter via localStorage.
  // The hub directory page will read this value on load, apply the filter, then clear it.
  var PENDING_TAG_KEY = "hub-directory:pending-tag";

  var tagLinks = Array.prototype.slice.call(
    document.querySelectorAll("a[data-hub-preset-tag]"),
  );
  if (!tagLinks.length) {
    return;
  }

  function setPendingTag(slug) {
    if (!slug) {
      return;
    }
    try {
      if (window.localStorage) {
        window.localStorage.setItem(PENDING_TAG_KEY, slug);
      }
    } catch (e) {
      // ignore (storage may be blocked)
    }
  }

  for (var i = 0; i < tagLinks.length; i += 1) {
    (function (link) {
      link.addEventListener("click", function (e) {
        var slug = link.getAttribute("data-hub-preset-tag") || "";
        setPendingTag(slug);

        // If hub-directory exists on this page, apply immediately (no navigation/reload).
        var root = document.querySelector("[data-hub-directory]");
        if (!root || !slug) {
          return;
        }
        var btn = root.querySelector('[data-hub-tag="' + slug + '"]');
        if (!btn) {
          return;
        }

        e.preventDefault();
        btn.click();

        // Mirror hub-directory scroll behavior so results are visible after click.
        var y = root.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: y, behavior: "smooth" });
      });
    })(tagLinks[i]);
  }
})();

(function () {
  var root = document.querySelector("[data-hub-directory]");
  if (!root) {
    return;
  }

  // Guard against double-init (e.g. turbo/pjax style nav)
  if (root.getAttribute("data-hub-init") === "true") {
    return;
  }
  root.setAttribute("data-hub-init", "true");

  var apiKeyEl = root.querySelector("[data-hub-content-api-key]");
  var siteUrlEl = root.querySelector("[data-hub-site-url]");
  var grid = root.querySelector("[data-hub-card-grid]");
  var loadMoreBtn = root.querySelector("[data-hub-load-more]");
  var tagSearchInput = root.querySelector("[data-hub-tag-search]");
  var directoryTitleEl = root.querySelector(".hub-directory__title");
  var tagButtons = Array.prototype.slice.call(
    root.querySelectorAll("[data-hub-tag]"),
  );

  if (!apiKeyEl || !siteUrlEl || !grid || !loadMoreBtn || !tagButtons.length) {
    return;
  }

  // Casper Learn style: read the content API key from the hidden DOM node.
  var GHOST_CONTENT_API_KEY = (apiKeyEl.textContent || "").trim();
  var siteUrl = (siteUrlEl.getAttribute("data-hub-site-url") || "").trim();

  // Use the pathname derived from @site.url so this works when Ghost is installed in a subdirectory.
  // Important: `new URL(relative, base)` treats a base WITHOUT a trailing slash as a "file".
  // Example: base "https://x.com/blog" + "ghost/api" => "https://x.com/ghost/api" (WRONG)
  // So we force a trailing slash first.
  var apiPath = "/ghost/api/content/posts/";
  try {
    if (siteUrl) {
      var siteUrlBase = siteUrl.replace(/\/?$/, "/");
      apiPath = new URL("ghost/api/content/posts/", siteUrlBase).pathname;
    }
  } catch (e) {
    // Fallback: best-effort absolute path (keeps subdirectory)
    if (siteUrl) {
      apiPath = siteUrl.replace(/\/$/, "") + "/ghost/api/content/posts/";
    }
  }

  var limit = 8;
  var activeTag = "all";
  var nextPage = 2;
  var searchQuery = "";
  var PENDING_TAG_KEY = "hub-directory:pending-tag";
  var authorSlug = (root.getAttribute("data-hub-author") || "").trim();

  // If a hub title exists (index/author pages), keep it as the default and
  // swap it for the active tag label when a filter is applied.
  var defaultDirectoryTitle = "";
  if (directoryTitleEl) {
    defaultDirectoryTitle = (directoryTitleEl.textContent || "").trim();
  }
  var hubTitleMode = (root.getAttribute("data-hub-title-mode") || "").trim();

  function getPendingTag() {
    try {
      if (window.localStorage) {
        return (window.localStorage.getItem(PENDING_TAG_KEY) || "").trim();
      }
    } catch (e) {
      // ignore
    }
    return "";
  }

  function clearPendingTag() {
    try {
      if (window.localStorage) {
        window.localStorage.removeItem(PENDING_TAG_KEY);
      }
    } catch (e) {
      // ignore
    }
  }

  function findTagButton(slug) {
    if (!slug) {
      return null;
    }
    for (var i = 0; i < tagButtons.length; i += 1) {
      if ((tagButtons[i].getAttribute("data-hub-tag") || "") === slug) {
        return tagButtons[i];
      }
    }
    return null;
  }

  function setDirectoryTitleForTag(slug) {
    if (!directoryTitleEl) {
      return;
    }

    // Only the index page should have a dynamic "Explore {Tag}" title.
    if (hubTitleMode !== "explore") {
      return;
    }

    var s = (slug || "").trim();
    if (!s || s === "all") {
      // Restore the server-rendered hub title (e.g. "Explore Everything").
      directoryTitleEl.textContent = defaultDirectoryTitle;
      return;
    }

    var btn = findTagButton(s);
    var label = btn ? (btn.textContent || "").trim() : "";
    if (!label) {
      directoryTitleEl.textContent = defaultDirectoryTitle;
      return;
    }

    directoryTitleEl.textContent = "Explore " + label;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  // Ensure the active filter tag appears first inside each post's tag pill list.
  // Works for both server-rendered cards and API-rendered cards.
  function reorderTagsInCard(card, slug) {
    if (!card || !card.querySelectorAll) {
      return;
    }

    var tagsWrap = card.querySelector(".hub-card__tags");
    if (!tagsWrap) {
      return;
    }

    var pills = Array.prototype.slice.call(
      tagsWrap.querySelectorAll(".hub-card__tag[data-hub-filter-tag]"),
    );
    if (pills.length < 2) {
      return;
    }

    // Persist original order so we can restore it when "All" is selected.
    pills.forEach(function (pill, idx) {
      if (!pill.getAttribute("data-hub-original-index")) {
        pill.setAttribute("data-hub-original-index", String(idx));
      }
    });

    var active = (slug || "").trim();
    var isAll = !active || active === "all";

    pills.sort(function (a, b) {
      var aIdx = parseInt(a.getAttribute("data-hub-original-index") || "0", 10);
      var bIdx = parseInt(b.getAttribute("data-hub-original-index") || "0", 10);

      if (isAll) {
        return aIdx - bIdx;
      }

      var aSlug = a.getAttribute("data-hub-filter-tag") || "";
      var bSlug = b.getAttribute("data-hub-filter-tag") || "";
      var aIsActive = aSlug === active;
      var bIsActive = bSlug === active;

      if (aIsActive !== bIsActive) {
        return aIsActive ? -1 : 1;
      }

      // Stable: keep original ordering within groups.
      return aIdx - bIdx;
    });

    pills.forEach(function (pill) {
      tagsWrap.appendChild(pill);
    });
  }

  function reorderTagsInAllCards(slug) {
    var posts = Array.prototype.slice.call(
      grid.querySelectorAll("[data-hub-post]"),
    );
    posts.forEach(function (post) {
      reorderTagsInCard(post, slug);
    });
  }

  function setActive(btn) {
    tagButtons.forEach(function (b) {
      var isActive = b === btn;
      b.classList.toggle("is-active", isActive);
      b.setAttribute("aria-pressed", String(isActive));
    });
  }

  function applyClientSearch() {
    var posts = Array.prototype.slice.call(
      grid.querySelectorAll("[data-hub-post]"),
    );
    posts.forEach(function (post) {
      var title = (
        post.getAttribute("data-hub-post-title") || ""
      ).toLowerCase();
      post.hidden = Boolean(searchQuery) && title.indexOf(searchQuery) === -1;
    });
  }

  function buildApiUrl(tagSlug, page, reqLimit) {
    var filterParts = [];
    if (authorSlug) {
      filterParts.push("authors:" + authorSlug);
    }
    if (tagSlug && tagSlug !== "all") {
      filterParts.push("tags:" + tagSlug);
    }

    var filter = encodeURIComponent(filterParts.join("+"));

    return (
      apiPath +
      "?key=" +
      encodeURIComponent(GHOST_CONTENT_API_KEY) +
      "&include=tags,authors" +
      (filter ? "&filter=" + filter : "") +
      "&limit=" +
      reqLimit +
      "&page=" +
      page
    );
  }

  function createCard(post) {
    var title = escapeHtml(post.title || "");
    var url = escapeHtml(post.url || "#");
    var featureImage = post.feature_image ? escapeHtml(post.feature_image) : "";

    // Render all public tags (not just primary tag), matching server-rendered markup.
    var publicTags = Array.isArray(post.tags)
      ? post.tags.filter(function (t) {
          return t && t.slug && t.name && t.visibility === "public";
        })
      : [];

    // When a tag filter is active, show that tag first (if the post has it).
    if (activeTag && activeTag !== "all" && publicTags.length > 1) {
      publicTags = publicTags.slice().sort(function (a, b) {
        var aIsActive = (a.slug || "") === activeTag;
        var bIsActive = (b.slug || "") === activeTag;
        if (aIsActive !== bIsActive) {
          return aIsActive ? -1 : 1;
        }
        return 0;
      });
    }

    var tagsHtml = "";
    if (publicTags.length) {
      tagsHtml =
        '<div class="hub-card__tags" aria-label="Post tags">' +
        publicTags
          .map(function (t, idx) {
            return (
              '<button type="button" class="hub-card__tag" data-hub-filter-tag="' +
              escapeHtml(t.slug || "") +
              '" data-hub-original-index="' +
              String(idx) +
              '">' +
              escapeHtml(t.name || "") +
              "</button>"
            );
          })
          .join("") +
        "</div>";
    }

    var authorName = post.primary_author
      ? escapeHtml(post.primary_author.name || "")
      : "";
    var authorUrl =
      post.primary_author && post.primary_author.url
        ? escapeHtml(post.primary_author.url)
        : "";
    var publishedAt = post.published_at ? new Date(post.published_at) : null;
    var dateText = publishedAt
      ? publishedAt.toLocaleDateString(undefined, {
          month: "short",
          day: "2-digit",
          year: "numeric",
        })
      : "";
    var readingTime = post.reading_time ? post.reading_time + " min read" : "";

    var tags = Array.isArray(post.tags)
      ? post.tags
          .map(function (t) {
            return t.slug;
          })
          .filter(Boolean)
          .join(",")
      : "";

    return (
      '<article class="hub-card" data-hub-post data-hub-post-title="' +
      title +
      '" data-tags="' +
      escapeHtml(tags) +
      '">' +
      '<div class="hub-card__media">' +
      (featureImage
        ? '<img src="' +
          featureImage +
          '" alt="' +
          title +
          '" loading="lazy" />'
        : "") +
      "</div>" +
      '<div class="hub-card__content">' +
      tagsHtml +
      '<h3 class="hub-card__title"><a href="' +
      url +
      '">' +
      title +
      "</a></h3>" +
      '<div class="hub-card__meta">' +
      (authorName
        ? '<p class="hub-card__author">By ' +
          (authorUrl
            ? '<a href="' + authorUrl + '">' + authorName + "</a>"
            : authorName) +
          "</p>"
        : "") +
      '<div class="hub-card__meta-row">' +
      (dateText ? "<time>" + escapeHtml(dateText) + "</time>" : "") +
      '<span class="hub-meta__dot" aria-hidden="true"></span>' +
      "<span>" +
      escapeHtml(readingTime) +
      "</span>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</article>"
    );
  }

  function fetchAndRenderPosts(tagSlug, fetchNext) {
    if (!GHOST_CONTENT_API_KEY) {
      console.warn("[hub-directory] Missing content API key");
      loadMoreBtn.hidden = true;
      return Promise.resolve();
    }

    var page = fetchNext ? nextPage : 1;
    var apiUrl = buildApiUrl(tagSlug, page, limit);

    return fetch(apiUrl)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!fetchNext) {
          grid.innerHTML = "";
        }

        if (data.posts && data.posts.length) {
          data.posts.forEach(function (post) {
            grid.insertAdjacentHTML("beforeend", createCard(post));
          });
        } else if (!fetchNext) {
          grid.innerHTML = "<p>No posts found.</p>";
        }

        var next =
          data.meta && data.meta.pagination ? data.meta.pagination.next : null;
        console.log(next, loadMoreBtn);
        // Learn-style pagination state updates
        if (fetchNext && next) {
          nextPage = next;
        } else if (!fetchNext && next) {
          nextPage = 2;
        } else {
          nextPage = 1;
        }

        // Requirement: if next is null, hide load more (check every fetch)
        loadMoreBtn.hidden = !next;

        applyClientSearch();
        reorderTagsInAllCards(activeTag);
      })
      .catch(function (error) {
        console.error("[hub-directory] Error fetching posts:", error);
        if (!fetchNext) {
          grid.innerHTML = "<p>Error loading posts.</p>";
        }
        loadMoreBtn.hidden = true;
      });
  }

  // Initial visibility should be based on pagination.next, without replacing server-rendered posts.
  function refreshLoadMoreVisibility(tagSlug) {
    if (!GHOST_CONTENT_API_KEY) {
      loadMoreBtn.hidden = true;
      return Promise.resolve();
    }

    var apiUrl = buildApiUrl(tagSlug, 1, 1);

    return fetch(apiUrl)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var next =
          data.meta && data.meta.pagination ? data.meta.pagination.next : null;
        loadMoreBtn.hidden = !next;
        nextPage = next ? 2 : 1;
      })
      .catch(function () {
        loadMoreBtn.hidden = true;
      });
  }

  // Tag clicks (single tag at a time)
  tagButtons.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var slug = btn.getAttribute("data-hub-tag") || "all";
      activeTag = slug;
      setActive(btn);
      setDirectoryTitleForTag(activeTag);
      fetchAndRenderPosts(activeTag, false).then(function () {
        var y = root.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: y, behavior: "smooth" });
      });
    });
  });

  // Tag click from card pill
  root.addEventListener("click", function (e) {
    var target = e.target;
    if (!target || target.nodeType !== 1 || !target.closest) {
      return;
    }

    var pill = target.closest("[data-hub-filter-tag]");
    if (!pill) {
      return;
    }

    var slug = pill.getAttribute("data-hub-filter-tag") || "";
    if (!slug) {
      return;
    }

    // Find matching sidebar button
    var match = null;
    for (var i = 0; i < tagButtons.length; i += 1) {
      if ((tagButtons[i].getAttribute("data-hub-tag") || "") === slug) {
        match = tagButtons[i];
        break;
      }
    }

    if (!match) {
      return;
    }

    activeTag = slug;
    setActive(match);
    setDirectoryTitleForTag(activeTag);
    fetchAndRenderPosts(activeTag, false).then(function () {
      var y = root.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: y, behavior: "smooth" });
    });
  });

  function filterTags(query) {
    var q = (query || "").toLowerCase().trim();

    var matches = 0;
    tagButtons.forEach(function (btn) {
      var slug = (btn.getAttribute("data-hub-tag") || "").toLowerCase();
      var label = (btn.textContent || "").toLowerCase();

      // Always show "All"
      if (slug === "all") {
        btn.hidden = false;
        return;
      }

      var isActive = btn.classList.contains("is-active");
      var isMatch = !q || label.indexOf(q) !== -1;

      // Keep the active tag visible even if it doesn't match the search.
      btn.hidden = !(isMatch || isActive);
      if (!btn.hidden) {
        matches += 1;
      }
    });

    var emptyEl = root.querySelector("[data-hub-tag-empty]");
    if (!emptyEl) {
      emptyEl = document.createElement("p");
      emptyEl.className = "hub-filter-empty";
      emptyEl.setAttribute("data-hub-tag-empty", "true");
      emptyEl.textContent = "No tags found";

      var filtersCard = root.querySelector(".hub-filters-card");
      if (filtersCard) {
        filtersCard.appendChild(emptyEl);
      }
    }

    emptyEl.hidden = !(q && matches === 0);
  }

  // Tag search (filters the tag list in the sidebar)
  if (tagSearchInput) {
    tagSearchInput.addEventListener("input", function () {
      filterTags(tagSearchInput.value || "");
    });
  }

  function scrollToDirectoryTop() {
    var y = root.getBoundingClientRect().top + window.pageYOffset - 120;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  // Load more (API paging)
  loadMoreBtn.hidden = true; // default hidden; will be flipped based on pagination.next
  var pendingTag = getPendingTag();
  var appliedPending = false;
  if (pendingTag && pendingTag !== "all") {
    var pendingBtn = findTagButton(pendingTag);
    if (pendingBtn) {
      appliedPending = true;
      activeTag = pendingTag;
      setActive(pendingBtn);
      setDirectoryTitleForTag(activeTag);
      fetchAndRenderPosts(activeTag, false).then(function () {
        // Requirement: clear after filter is applied and data fetched
        clearPendingTag();
        // Match sidebar tag click behavior: bring user to the list after results render
        scrollToDirectoryTop();
      });
    }
  }

  if (!appliedPending) {
    if (pendingTag) {
      clearPendingTag();
    }
    refreshLoadMoreVisibility(activeTag);
  }

  loadMoreBtn.addEventListener("click", function () {
    fetchAndRenderPosts(activeTag, true);
  });
})();

(function () {
  var root = document.querySelector("[data-blog-post-layout]");
  if (!root) {
    return;
  }

  // Guard against double-init
  if (root.getAttribute("data-post-init") === "true") {
    return;
  }
  root.setAttribute("data-post-init", "true");

  var content = root.querySelector("[data-blog-post-content]");
  var tocCard = root.querySelector("[data-post-toc]");
  var tocList = root.querySelector("[data-post-toc-list]");

  if (!content || !tocCard || !tocList) {
    return;
  }

  function slugify(text) {
    return String(text || "")
      .toLowerCase()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function uniqueId(base) {
    var id = base || "section";
    var n = 2;
    while (document.getElementById(id)) {
      id = base + "-" + n;
      n += 1;
    }
    return id;
  }

  function ensureHeadingId(el, index) {
    if (!el) {
      return "";
    }
    var existing = el.getAttribute("id");
    if (existing) {
      return existing;
    }
    var label = (el.textContent || "").trim();
    var base = slugify(label) || "section-" + (index + 1);
    var id = uniqueId(base);
    el.setAttribute("id", id);
    return id;
  }

  function buildToc() {
    var headings = Array.prototype.slice.call(content.querySelectorAll("h2"));

    // Clear existing TOC
    tocList.innerHTML = "";

    if (!headings.length) {
      tocCard.hidden = true;
      return;
    }

    tocCard.hidden = false;

    for (var i = 0; i < headings.length; i += 1) {
      var h = headings[i];
      var text = (h.textContent || "").trim();
      if (!text) {
        continue;
      }

      var id = ensureHeadingId(h, i);
      if (!id) {
        continue;
      }

      var li = document.createElement("li");
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "post-toc-link";
      btn.textContent = text;
      btn.setAttribute("data-post-toc-target", id);
      li.appendChild(btn);
      tocList.appendChild(li);
    }
  }

  // Smooth scroll on TOC click
  tocCard.addEventListener("click", function (e) {
    var target = e && e.target ? e.target : null;
    if (!target || !target.closest) {
      return;
    }
    var btn = target.closest("[data-post-toc-target]");
    if (!btn) {
      return;
    }
    e.preventDefault();

    // Active state (matches Figma "Active" style)
    var all = tocList.querySelectorAll("[data-post-toc-target]");
    for (var i = 0; i < all.length; i += 1) {
      all[i].classList.remove("is-active");
    }
    btn.classList.add("is-active");

    var id = btn.getAttribute("data-post-toc-target") || "";
    if (!id) {
      return;
    }
    var el = document.getElementById(id);
    if (!el) {
      return;
    }

    var y = el.getBoundingClientRect().top + window.pageYOffset - 120;
    window.scrollTo({ top: y, behavior: "smooth" });
  });

  buildToc();

  // Share actions (structure now; content later if needed)
  var copyBtn = root.querySelector('[data-post-share="copy"]');
  if (copyBtn) {
    var copyFeedbackTimer = null;
    function showCopyFeedback() {
      var feedback = document.getElementById("copy-feedback");
      if (!feedback) {
        return;
      }
      feedback.style.opacity = "1";
      feedback.style.pointerEvents = "auto";
      if (copyFeedbackTimer) {
        clearTimeout(copyFeedbackTimer);
        copyFeedbackTimer = null;
      }
      copyFeedbackTimer = setTimeout(function () {
        feedback.style.opacity = "0";
        feedback.style.pointerEvents = "none";
      }, 1800);
    }

    copyBtn.addEventListener("click", function () {
      var url = "";
      try {
        url =
          window.location && window.location.href ? window.location.href : "";
      } catch (e) {
        url = "";
      }
      if (!url) {
        return;
      }

      function fallbackCopy(text) {
        var input = document.createElement("input");
        input.value = text;
        input.setAttribute("readonly", "true");
        input.style.position = "fixed";
        input.style.left = "-9999px";
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
        } catch (e) {
          // noop
        }
        document.body.removeChild(input);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(url)
          .then(function () {
            showCopyFeedback();
          })
          .catch(function () {
            fallbackCopy(url);
            showCopyFeedback();
          });
      } else {
        fallbackCopy(url);
        showCopyFeedback();
      }
    });
  }

  function setShareHref(selector, href) {
    var el = root.querySelector(selector);
    if (!el) {
      return;
    }
    el.setAttribute("href", href);
    el.setAttribute("rel", "noopener noreferrer");
    el.setAttribute("target", "_blank");
  }

  // Build share URLs
  var shareUrl = "";
  var shareTitle = "";
  try {
    shareUrl =
      window.location && window.location.href ? window.location.href : "";
  } catch (e) {
    shareUrl = "";
  }
  try {
    shareTitle = document && document.title ? document.title : "";
  } catch (e) {
    shareTitle = "";
  }

  if (shareUrl) {
    setShareHref(
      '[data-post-share="linkedin"]',
      "https://www.linkedin.com/sharing/share-offsite/?url=" +
        encodeURIComponent(shareUrl),
    );
    setShareHref(
      '[data-post-share="x"]',
      "https://twitter.com/intent/tweet?url=" +
        encodeURIComponent(shareUrl) +
        (shareTitle ? "&text=" + encodeURIComponent(shareTitle) : ""),
    );
  }

  // Mobile sticky "Book a demo" CTA (appears as you cross the hero author name)
  (function () {
    var sticky = document.querySelector("[data-post-sticky-demo]");
    var trigger = document.querySelector("[data-post-sticky-demo-trigger]");

    if (!sticky || !trigger) {
      return;
    }

    function isMobile() {
      if (!window.matchMedia) {
        return false;
      }
      return window.matchMedia("(max-width: 640px)").matches;
    }

    function setVisible(next) {
      var show = Boolean(next) && isMobile();
      sticky.classList.toggle("is-visible", show);
      document.body.classList.toggle("has-post-sticky-demo", show);
      sticky.setAttribute("aria-hidden", String(!show));
    }

    // Default hidden
    setVisible(false);

    function getNavbarOffset() {
      var navbar = document.querySelector("[data-fc-navbar]");
      if (!navbar || !navbar.getBoundingClientRect) {
        return 0;
      }
      return navbar.getBoundingClientRect().height || 0;
    }

    function computeShouldShow() {
      if (!isMobile()) {
        return false;
      }
      var rect = trigger.getBoundingClientRect();
      var offset = getNavbarOffset();
      // Show right after the author name scrolls past the top (under the fixed navbar).
      return rect.top <= offset;
    }

    var last = null;
    function update() {
      var next = computeShouldShow();
      if (last === next) {
        return;
      }
      last = next;
      setVisible(next);
    }

    var ticking = false;
    function onScrollOrResize() {
      if (ticking) {
        return;
      }
      ticking = true;
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      } else {
        window.setTimeout(function () {
          update();
          ticking = false;
        }, 60);
      }
    }

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);

    var mql = window.matchMedia
      ? window.matchMedia("(max-width: 640px)")
      : null;
    if (mql) {
      if (mql.addEventListener) {
        mql.addEventListener("change", onScrollOrResize);
      } else if (mql.addListener) {
        mql.addListener(onScrollOrResize);
      }
    }

    update();
  })();
})();
